import { supabase } from '../supabaseClient';

async function getProjectsFromRpc() {
    var query;
    query = supabase.rpc('allactiveprojects', {}, { count: 'exact' })
    query = query.or(`launchid.is.null,eventstartdatetime.lte.${Date.now()}`)
    query = query.or(`launchid.is.null,eventenddatetime.gte.${Date.now()}`);
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}

async function getAllProjects() {

    let query = supabase.from('Projects').select('*').eq('isCompleted', true).eq('isPublished' , true).eq('isVJ', true);
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}


async function getLaunches(eventId) {

    let query = supabase.from('Launches').select('*,projectId(*),eventId(*)').eq('eventId', eventId);
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}
async function getAllLaunchesByProject(projectId) {
    const { data, count, error } = await supabase.from('Launches').select('*').eq('projectId', projectId)
    if (data) return { data, count };
    else throw error;
}

async function getActiveLaunchInventory(unitId) {
    const { data, count, error } = await supabase
        .from('LaunchInventoryRelations')
        .select('*,unitId(*,projectId(*)),wingId(*),launchId(*,eventId(*))')
        .eq('unitId', unitId)
        .lt('launchId.eventId.startDateTime', new Date().getTime())
        .gt('launchId.eventId.endDateTime', new Date().getTime())
    if (data) return { data, count };
    else throw error;
}

async function getFutureLaunchInventory(unitId) {
    const { data, count, error } = await supabase
        .from('LaunchInventoryRelations')
        .select('*,unitId(*,projectId(*)),wingId(*),launchId(*,eventId(*))')
        .eq('unitId', unitId)
        .gt('launchId.eventId.startDateTime', new Date().getTime())
    if (data) return { data, count };
    else throw error;
}
// Get Event From launch

async function getLaunchBy(unitId) {
    const { data, count, error } = await supabase.from('LaunchInventoryRelations')
        .select('*,launchId(*,eventId(*))').eq('unitId', unitId)
        .lt('launchId.eventId.startDateTime', new Date().getTime())
    if (data) return { data, count };
    else throw error;
}
//by launch id
async function getEventInfo(launchId) {
    const { data, count, error } = await supabase.from('Launches')
        .select('*,eventId(*),projectId(*)', { count: 'exact' })
        .eq('launchId', launchId);
    if (data) return { data, count };
    else throw error;
}
// ??getting Available units only
// LaunchInvertoryRelation
async function getAvailableIdInventoryStatus(){
    const {data,error} =await supabase
    .from('InventoryStatus')
    .select('*')
     .eq('status', 'Available').single();
    if (data) return { data };
    else throw error;
  }
async function getAllUnitsByWingIdWithMerged(projectId, wingId, search) {
    let statusId=  await getAvailableIdInventoryStatus();
    console.log(search);
    let query;
    query = supabase
        .from('Inventory')
        .select('* , inventoryTypeId(*) ,InventoryStatus(*),inventoryMergeId(*)', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        .eq('InventoryStatus.inventoryStatusId', statusId.data.inventoryStatusId)

    if (search) {
        query = query.eq('unitNo', search);
    }
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

// ??Get LaunchInventory
async function getAllUnitsFromLaunches(launchId,wingId) {
    let statusId=  await getAvailableIdInventoryStatus();
    let query;
    query = supabase
        .from('LaunchInventoryRelations')
        .select('*,launchId(*,eventId(*)),unitId(*,inventoryTypeId(*),inventoryMergeId(*,unit1Id(*,inventoryTypeId(*)),unit2Id(*,inventoryTypeId(*))),wingId(*))')
        .eq('launchId', launchId)
        .eq('wingId', wingId)
    // .filter('unitId.inventoryStatusId', 'in', '("51c40f6a-176d-4ef9-a2a7-a2c0569da025")')
    .eq('unitId.inventoryStatusId', statusId.data.inventoryStatusId)


    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}


async function getProjectPricing(projectId, wingId, inventoryTypeId) {
    const { data, error, count } = await supabase
        .from('ProjectPricing')
        .select('*', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        .eq('inventoryTypeId', inventoryTypeId);
    if (data) return { data, count };
    else throw error;
}

// ??Sustenance checks

async function getSustenanceProjectInventory(projectId, wingId) {
    let statusId=  await getAvailableIdInventoryStatus();
    let query = supabase
        .from('ProjectInventoryRelations')
        .select('*,wingId(*),unitId(*,inventoryMergeId(*,unit1Id(*,inventoryTypeId(*)),unit2Id(*,inventoryTypeId(*))),inventoryTypeId(*))')
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        // .filter('unitId.inventoryStatusId', 'in', '("51c40f6a-176d-4ef9-a2a7-a2c0569da025")')
        .eq('unitId.inventoryStatusId', statusId.data.inventoryStatusId)

    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}
async function getSustenanceLaunchInventory(projectId, wingId) {
    let statusId=  await getAvailableIdInventoryStatus();
    let query = supabase
        .from('LaunchInventoryRelations')
        .select('*,launchId(*,eventId(*)),unitId(*,inventoryTypeId(*),inventoryMergeId(*,unit1Id(*,inventoryTypeId(*)),unit2Id(*,inventoryTypeId(*))),wingId(*))')
        .eq('launchId.projectId', projectId)
        .eq('wingId', wingId)
        // .filter('unitId.inventoryStatusId', 'in', '("51c40f6a-176d-4ef9-a2a7-a2c0569da025")')
        .eq('unitId.inventoryStatusId', statusId.data.inventoryStatusId)

        // .lt('launchId.eventId.endDateTime', Date.now());

    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}

// ??getWings by launchId rpc
async function getWingsByLaunchIdFromRpc(launchId) {
    var query;
    query = supabase.rpc('getwingsbylaunch', { launchid: launchId }, { count: 'exact' })
    const { data, count, error } = await query
    if (data) return { data, count };
    else throw error;
}

async function getProjectDataByProjectId(projectId) {
    const { data, error, count } = await supabase
        .from('Projects')
        .select('*', { count: 'exact' })
        .eq('projectId', projectId)
    if (data) return { data, count };
    else throw error;
}

export {
    getProjectsFromRpc, getEventInfo, getAllProjects, getAllLaunchesByProject
    , getActiveLaunchInventory, getFutureLaunchInventory,
    getAllUnitsByWingIdWithMerged, getProjectPricing, getLaunches,
    getSustenanceProjectInventory, getSustenanceLaunchInventory,
    getAllUnitsFromLaunches, getWingsByLaunchIdFromRpc, getProjectDataByProjectId
}